// Central image asset URLs for the marketing site.
// Keep these in one place so it's easy to update when new photos arrive.

const ASSET_BASE =
    "https://customer-assets.emergentagent.com/job_phone-case-designer-2/artifacts";

export const SITE_IMAGES = {
    // Real Vendagain phone case machine (Case Laboratory branded) — Westfield WA
    caseMachineAngle: `${ASSET_BASE}/71xdqsii_69ad3000-11c5-49af-a72f-2059ee0998dd.webp`,
    caseMachineFront: `${ASSET_BASE}/ug2224cj_87aba513-a16d-4153-84f9-1cad3c043878.webp`,

    // Royal Vending Machines — stock photos
    rvmCombo: `${ASSET_BASE}/zx2waih6_RVM4.jfif`,     // smaller combo unit
    rvmComboTall: `${ASSET_BASE}/vshlp4ra_RVM5.jfif`, // taller premium combo
};

// Social links
export const SOCIAL = {
    tiktok: "https://www.tiktok.com/@vendagain",
    instagram: null, // add when available
};

// Featured TikTok video shown in the Case Designer sidebar.
// To change the video: paste the full URL and the video ID (the last segment)
// will be extracted automatically at render time.
export const FEATURED_TIKTOK = {
    url: "https://www.tiktok.com/@vendagain/video/7636623824879947016",
    videoId: "7636623824879947016",
    username: "vendagain",
};

// Discount code hunt config.
// Reveal code that unlocks the "you found it" reward.
// Keep this in sync with your coupon system.
export const HUNT_CODE = "410784187";
